import { Record as record } from 'immutable';

import config from '../../../src/config';
import ValidationMixin from '../../../src/records/ValidationMixin';
import validators from '../../../src/validation';
import { Validation } from '../../../src/constants/AppConstants';
import Address from '../../../src/records/customer/Address';
import { construct, resolve, fields } from '../../../src/helpers/LinkMapper';
import UserPreferences, { PreferenceType } from '../../../src/records/customer/UserPreferences';

const defaults = {
    title: config.get('customerTitles')[0],
    firstNames: null,
    surname: null,
    email: null,
    confirmemail: null,
    phone: null,
    address: new Address(),
    storedAddress: null,
    password: null,
    isOver16: false,
    preferences: new UserPreferences(),
    acceptedTAndCs: false
};

class DelayRepayCustomerDetails extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(DelayRepayCustomerDetails, json, {
            title: fields.string,
            firstNames: fields.string,
            surname: fields.string,
            email: fields.string,
            confirmemail: fields.string,
            phone: fields.string,
            address: resolve.as(Address),
            storedAddress: resolve.as(Address),
            password: fields.string,
            preferences: resolve.as(UserPreferences),
            acceptedTAndCs: fields.bool
        });
    }

    getComputedValues () {
        return {
            address: !!this.storedAddress || this.address && this.address.isComplete()
        };
    }

    get contactName () {
        return `${this.title} ${this.firstNames} ${this.surname}`.trim();
    }

    mergeUser (user) {
        return this.merge({
            title: user.title,
            firstNames: user.firstNames,
            surname: user.surname,
            email: user.email,
            confirmemail: user.email,
            phone: Validation.telephone.test(this.phone) ? this.phone : user.telephoneNumber,
            address: this.address.set('contactName', user.fullName),
            password: null
        });
    }

    getSchema () {
        let schema = {
            title: validators.title(),
            firstNames: validators.name(2, 50),
            surname: validators.name(2, 50),
            email: validators.email(),
            confirmemail: validators.confirmEmail(),
            phone: validators.phone().required(),
            address: validators.true(),
            password: validators.passwordCreate().allow('', null)
        };

        if (this.password) {
            schema = Object.assign(schema, { acceptedTAndCs: validators.true() });
        }

        return schema;
    }

    serialize () {
        const address = this.storedAddress || this.address;
        return {
            title: this.title,
            firstNames: this.firstNames,
            surname: this.surname,
            email: this.email,
            phoneNumber: this.phone,
            address: {
                line1: address.line1,
                line2: address.line2,
                line3: address.line3,
                town: address.town,
                postcode: address.postCode,
                country: address.country
            }
        };
    }

    toggleAllMarketingPreferences (method, value, isOver16) {
        let form = this;
        let updatedPreferences = this.preferences.toggleAllMarketingPreferences(method, value, isOver16);
        form = this.set('preferences', updatedPreferences);
        if (method === PreferenceType.SMS && !value) {
            form = form.set('phone', null);
        }
        return form;
    }

    resetAllDisabledMarketingFields () {
        const updatedPreferences = this.preferences.resetAllDisabledMarketingFields();
        return this.set('preferences', updatedPreferences);
    }
}

Object.assign(DelayRepayCustomerDetails.prototype, ValidationMixin);

export default DelayRepayCustomerDetails;
